module.exports = __webpack_public_path__ + "static/media/loader.e68e2654.gif";